import React from 'react';
import CardMainRender, {CardMainProps} from './CardMainRender';

export const CardMain = ({...props}:CardMainProps):JSX.Element => {
	return <CardMainRender {...props} />;
};



